"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Breadcrumbs = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./Breadcrumbs.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const filterValidElements = child => /*#__PURE__*/React.isValidElement(child);
/**
 * A breadcrumb trail consists of a list of links to the parent pages of the
 * current page in hierarchical order. It helps users find their place within a
 * website or web application.
 *
 * Breadcrumbs` are often placed horizontally before a page's main content.
 *
 * Breadcrumbs accepts children as an array of links, which will be rendered
 * with UI styles applied.
 */


const Breadcrumbs = ({
  children
}) => {
  const filteredChildren = React.Children.toArray(children).filter(filterValidElements);
  return filteredChildren.length > 0 ? (0, _pragma.createFelaElement)(_.Text, {
    as: "nav",
    "aria-label": "breadcrumb",
    variant: "meta"
  }, (0, _pragma.createFelaElement)(_.View, {
    as: "ol"
  }, React.Children.map(filteredChildren, (child, index) =>
  /* eslint-disable react/no-array-index-key */
  (0, _pragma.createFelaElement)(_.View, {
    alignItems: "center",
    as: "li",
    key: index
  }, index > 0 && (0, _pragma.createFelaElement)(_.Text, {
    "aria-hidden": true,
    css: css.seperator,
    children: "\u203A",
    color: "text.2",
    variant: "meta"
  }), /*#__PURE__*/React.cloneElement(child, {
    css: css.link
  }))
  /* eslint-enable */
  ))) : null;
};

exports.Breadcrumbs = Breadcrumbs;
Breadcrumbs.displayName = 'Breadcrumbs';
var _default = Breadcrumbs;
exports.default = _default;
//# sourceMappingURL=Breadcrumbs.js.map